import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import { Box } from '@mui/material';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import salesData from '../../Data/salesstatistics.json'; 

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const SalesStatistics = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(salesData); 
  }, []);

  return (
    <Box sx={{ width: "100%", height: "auto" }}>
      {data ? <Line data={data} /> : <p>Loading...</p>}
    </Box>
  );
};

export default SalesStatistics;
